/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Graphics.module.css';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
class Graphics extends Component {
 
  render() {
    // content will be built in the parent component
    const content = this.props.content;
    const viewBox = this.props.viewBox;

    return (
      <>
        <svg
          className={styles.graphics}
          id="svg"
          viewBox={viewBox}
          preserveAspectRatio="xMidYMid meet"
        >
          {content}
        </svg>
      </>
    );
  }
}

export default Graphics;
